import { v5 as uuidv5, v7 as uuidv7 } from "uuid";
import { z } from "zod";

/** Client-generated UUIDv7 ids on every entity (AGENTS.md §3.11). */
export const Id = z.uuid({ version: "v7" });
export type Id = z.infer<typeof Id>;

/** New time-ordered id. Generated by whoever creates the entity (client, hub or server), so offline creation works. */
export function newId(): Id {
  return uuidv7();
}

/** Fixed namespace for name-based ids (UUIDv5) of things identified by a name, e.g. a module. */
const NAME_NAMESPACE = "6f1c2a3e-8f4b-5d6a-9b7c-0e1f2a3b4c5d";

/** Stable id derived from a name: the same name always gives the same id. For audit entities without their own id. */
export function nameId(name: string): string {
  return uuidv5(name, NAME_NAMESPACE);
}
